<template>
    <div class="no-record-found table-spinner">
        <div class="middle-align">
            <div class="spinner-img">
                <img src="@/assets/images/loader.svg" class="main" />
                <p class="txt">Loading...</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        /*
            |--------------------------------------------------------------------------
            | Component > props
            |--------------------------------------------------------------------------
            */
        props: {}, // End of Component > props

        /*
            |--------------------------------------------------------------------------
            | Component > data
            |--------------------------------------------------------------------------
            */
        data() {
            return {}
        }, // End of Component > data

        /*
            |--------------------------------------------------------------------------
            | Component > computed
            |--------------------------------------------------------------------------
            */
        computed: {}, // End of Component > methods

        /*
            |--------------------------------------------------------------------------
            | Component > mounted
            |--------------------------------------------------------------------------
            */
        mounted() {}, // End of Component > computed

        /*
            |--------------------------------------------------------------------------
            | Component > methods
            |--------------------------------------------------------------------------
            */
        methods: {}, // End of Component > mounted
    } // End of export default
</script>
<style scoped>
    /* Styles for the page loader */
    .no-record-found {
        position: fixed; /* Fixed positioning to place the loader relative to the viewport */
        top: 0; /* Align the top edge of the loader to the top of the viewport */
        left: 0; /* Align the left edge of the loader to the left of the viewport */
        width: 100%; /* Stretch the loader to cover the full width of the viewport */
        height: 100%; /* Stretch the loader to cover the full height of the viewport */
        background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background to obscure the content below */
        backdrop-filter: blur(2px); /* Apply a blur effect to the background */
        display: flex; /* Enables the use of Flexbox for centering content */
        align-items: center; /* Vertically center the content within the loader */
        justify-content: center; /* Horizontally center the content within the loader */
        z-index: 1000; /* High z-index to ensure the loader appears above other content */
        pointer-events: all; /* Ensure the loader can be interacted with (if necessary) */
    }

    .middle-align {
        text-align: center; /* Center the text (and content) horizontally */
    }

    .spinner-img {
        display: inline-block; /* Allows the spinner image and text to be treated as one block for centering */
    }

    .spinner-img img.main {
        width: 50px; /* Adjust the size of the spinner image as needed */
        height: 50px; /* Adjust the height to match the width for consistency */
    }

    .spinner-img p {
        color: #fff; /* White text color for visibility against the semi-transparent black background */
        margin-top: 10px; /* Space between the image and the text */
    }
    .txt{
        color: black !important;
    }
</style>
